import 'reflect-metadata';
import {Expose} from 'class-transformer';
import {IsNumber, IsString} from 'class-validator';

class ApplicationModuleDataClass {
  @IsNumber()
  @Expose()
  id: number;

  @IsString()
  @Expose()
  name: string;

  @IsString()
  @Expose()
  description: string;

  @Expose()
  isActive: boolean;

  @Expose()
  created: Date;
}

export class ApplicationApi {
  public static Endpoints = {
    BaseRoute: 'app',
    ApplicationOption: 'data'
  }

  public static ApplicationModule = ApplicationModuleDataClass;
}